import { render, staticRenderFns } from "./EventSmall.vue?vue&type=template&id=096b1c72&"
import script from "./EventSmall.vue?vue&type=script&lang=js&"
export * from "./EventSmall.vue?vue&type=script&lang=js&"
import style0 from "./EventSmall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports